import * as React           from 'react';

import { Divider          } from '@mui/material';

import { VGap             } from 'src/components/common/flex/vgap';
import { Typography       } from 'src/components/common/typography';
 
import { ResultContainer,
         ResultItem,
         ResultHeader,
         ResultPrimary,
         ResultRoll,
         ResultEmpty,
         ResultVariants,
         result_variants  } from 'src/components/features/main/shade-selection/result/ui';

import * as types           from 'src/services/api/types';



type Props = {
  variant: ResultVariants;
  results: types.service.ShadeSelectionItem[];
}
export const Result: React.FC<Props> = ({
  variant,
  results
}) => {
  const lookAndFeel = result_variants.get(variant)!;

  return (
    <ResultContainer lookAndFeel = { lookAndFeel }>
      <Typography
        variant = { 'blackw500s16lh22' }
      >
        Результат подбора
      </Typography>
      {results.length > 0 && results.map((result, index) => (
        <ResultItem 
          lookAndFeel = { lookAndFeel }
          key = {`${result.pieceEtalon}_${result.pieces.map((roll) => roll.piece).join('_')}`}
        >
          <ResultHeader lookAndFeel = { lookAndFeel }>Комбинация допускается</ResultHeader>
          <VGap size = { 4 } />
          <ResultPrimary lookAndFeel = { lookAndFeel }>{ result.pieceEtalon }</ResultPrimary>
          {result.pieces.map((roll) => (
            <ResultRoll key = { roll.piece } lookAndFeel = { lookAndFeel }>{ roll.piece }</ResultRoll>
          ))}
          { index !== results.length - 1 && (
            <React.Fragment>
              <VGap size = { 10 } />
              <Divider />
            </React.Fragment>
          )}
        </ResultItem>
      ))}
      {results.length === 0 && (
        <ResultEmpty lookAndFeel = { lookAndFeel }>Комбинация не допускается</ResultEmpty>
      )}
    </ResultContainer>
  );
};
